import { render, staticRenderFns } from "./BandBookingForm.vue?vue&type=template&id=2c07b9c3"
import script from "./BandBookingForm.vue?vue&type=script&lang=js"
export * from "./BandBookingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports